let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("ae0TA")).then(() => parcelRequire('1tuhj'));